import { useRef } from 'react';

import { uuidv4 } from 'utils/uuidv4';
import { MiPlayer } from '../mi-player';
import { usePlayerApi } from '../mi-player/use-player-api';
import { VideoPlayerEmbed } from '../video-player-embed';

export const VideoPlayerWrapper = ({ playerConfiguration, video }) => {
  const { data: oldPlayerConfig } = usePlayerApi(playerConfiguration, video);
  const uuid = useRef(uuidv4()).current;

  return oldPlayerConfig ? (
    oldPlayerConfig.playerDefinition.version === '2' ? (
      // The player should load the config based on the player-id and video-id.
      // But because we already loaded the old config, we use it here.
      <MiPlayer
        playerConfiguration={oldPlayerConfig}
        playerId={playerConfiguration.playerDefinitionId}
        videoId={video.id}
      />
    ) : (
      // the old player
      <VideoPlayerEmbed id={`player-container__${uuid}`} playerConfiguration={playerConfiguration} video={video} />
    )
  ) : null;
};
